'use client';

import { useTranslations } from 'next-intl';
import type React from 'react';
import { FEATURE_ITEMS } from '../_constants/features';

export const FeatureGrid: React.FC = () => {
  const t = useTranslations('vidu-stream.features');

  return (
    <section className="w-full bg-black pt-24 pb-16 text-white sm:py-16">
      <div className="mx-auto w-full max-w-[1440px] px-8 sm:px-4">
        <h2 className="mb-12 text-center font-medium text-[40px] leading-[1.2] sm:mb-8 sm:text-[32px]">
          {t('sectionTitle')}
        </h2>
        <div className="grid grid-cols-2 gap-x-16 gap-y-16 sm:grid-cols-1">
          {FEATURE_ITEMS.map(({ key, image }) => {
            return (
              <div key={key} className="flex flex-col gap-3">
                <div className="mb-3 aspect-video w-full overflow-hidden rounded-8 bg-white/[0.04] p-2">
                  {image && (
                    <img
                      src={image}
                      alt={t(`${key}.title`)}
                      className="h-full w-full rounded-8 object-contain"
                      loading="lazy"
                    />
                  )}
                </div>
                <div className="flex flex-1 flex-col gap-2 px-3">
                  <h3 className="font-medium text-[28px] leading-[1.4] tracking-tight md:text-[24px]">
                    {t(`${key}.title`)}
                  </h3>
                  <p className="text-sm text-white/60 leading-[1.6] md:text-[13px]">{t(`${key}.description`)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
